import React, { useEffect, useState } from 'react';
import VarRevInsDetailPresentational from './VarRevInsDetailPresentational';
import { useLoading } from '../../../../commons/Loading';
import { useTranslation } from 'react-i18next';
import {
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params';
import {
  createBonus,
  getCondoReportsVariableRevenuesInsurances,
} from '../../../../lib/fetch/reports';
import { useDebouncedCallback } from 'use-debounce';
import { useAuth } from '../../../../commons/Auth';
import { useAlert } from 'react-alert';

const { REACT_APP_DEFAULT_PAGINATION_LIMIT = 50 } = process.env;

const VarRevInsDetail = (props) => {
  const { condoId, condo } = props;

  const { profile = {} } = props;
  const { showLoading, hideLoading } = useLoading();
  const alert = useAlert();
  const [{ newToken } = {}] = useAuth();
  const [t] = useTranslation('INSURANCES');

  const { _id: profileId } = profile;
  const [reports, setReports] = useState({
    categories: { gnet_admin: {}, supplier: {}, bonuses: { data: [] } },
    totals: {},
  });

  const [total, setTotal] = useState(0);

  const [query, setQuery] = useQueryParams({
    limit: withDefault(NumberParam, +REACT_APP_DEFAULT_PAGINATION_LIMIT),
    offset: NumberParam,
    year: withDefault(
      NumberParam,
      props.query?.year || new Date().getFullYear()
    ),
    insuranceStartMonth: NumberParam,
    policy_code: withDefault(StringParam, ''),
    admin_cf: withDefault(StringParam, ''),
    customer: withDefault(StringParam, ''),
    customerType: withDefault(StringParam, ''),
    active: withDefault(StringParam, ''),
    agencyType: withDefault(StringParam, ''),
  });

  const {
    limit,
    offset,
    year,
    insuranceStartMonth,
    policy_code,
    admin_cf,
    customer,
    customerType,
    active,
    agencyType,
  } = query;

  const [fetchReportsInsurances] = useDebouncedCallback(async () => {
    showLoading();
    const response = await getCondoReportsVariableRevenuesInsurances({
      limit,
      offset,
      year,
      insuranceStartMonth,
      policy_code,
      admin_cf,
      customer,
      customerType,
      active,
      newToken,
      profileId,
      condoId,
      condoVatCode: condo.vatCode,
      agencyType,
    });

    hideLoading();

    if (response instanceof Error) {
      return alert.error(t('COMMON:GENERIC_ERROR'));
    }

    const { data = [] } = response;
    setReports(data);
    setTotal(data.categories?.variableRevenuesInsurances?.count);
  }, 1000);

  useEffect(() => {
    fetchReportsInsurances();
  }, [
    limit,
    offset,
    year,
    insuranceStartMonth,
    policy_code,
    admin_cf,
    customer,
    customerType,
    active,
    agencyType,
  ]);

  function onFilter(queryDiff) {
    if (
      (queryDiff.year && queryDiff.year !== year) || // first search
      (year && queryDiff.year === '') || // search deleted
      (queryDiff.insuranceStartMonth &&
        queryDiff.insuranceStartMonth !== insuranceStartMonth) || // first search
      (insuranceStartMonth && queryDiff.insuranceStartMonth === '') || // search deleted
      (queryDiff.policy_code && queryDiff.policy_code !== policy_code) || // first search
      (policy_code && queryDiff.policy_code === '') || // search deleted
      (queryDiff.agencyType && queryDiff.agencyType !== agencyType) || // first search
      (agencyType && queryDiff.agencyType === '') || // search deleted
      (queryDiff.admin_cf && queryDiff.admin_cf !== admin_cf) || // first search
      (admin_cf && queryDiff.admin_cf === '') || // search deleted
      (queryDiff.customer && queryDiff.customer !== customer) || // first search
      (customer && queryDiff.customer === '') || // search deleted
      (queryDiff.customerType && queryDiff.customerType !== customerType) || // first search
      (customerType && queryDiff.customerType === '') || // search deleted
      (queryDiff.active && queryDiff.active !== active) || // first search
      (active && queryDiff.active === '') || // search deleted
      (queryDiff.limit && queryDiff.limit !== limit)
    ) {
      queryDiff.offset = 0; // return to first page
    }

    setQuery(queryDiff);
  }

  return (
    <VarRevInsDetailPresentational
      data={reports}
      onFilter={onFilter}
      query={query}
      total={total}
      profileType={profile.type}
      {...props}
    />
  );
};

export default VarRevInsDetail;
